import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
   container: {
     padding: "0 !important",
   },
   tablebox: {
     padding: "15px",
     background: theme.palette.background.paper,
     borderRadius: "8px",
   },
   norecord: {
     display: "flex",
     justifyContent: "center",
     alignItems: "center",
     minHeight: "300px",
   },
   buttonmargin:{
    '& button': {
      marginLeft:"10px"
    }
   },
   bg:{
    background: theme.palette.background.bg,
    padding:"5px 15px"
   },   
   mainstep:{
      marginBottom:"40px"
   },
   pt0:{
     paddingTop:"0px !important"
   },
   ratesTableWrapper: {
     '& .p-datatable .p-datatable-row-expansion > td': {
       padding: '0 !important'
     }
   }
}));
